import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterOption } from '../../models/filter-option.model';

@Component({
  selector: 'app-options-select',
  templateUrl: './options-select.component.html',
  styleUrl: './options-select.component.css'
})
export class OptionsSelectComponent {

  @Input() element: FilterOption;

  @Output() selected = new EventEmitter();

  selection(item){
    if(item.children) return;
    this.selected.emit(item);
  }
}
